import type { ConstructionSite } from "../model/ConstructionSite";
import type { ConstructionSiteService } from "../port/ConstructionSiteService";
import type { CreateConstructionSiteIntakeCommand } from "../model/ConstructionSite";

export class CreateConstructionSiteIntake {
  constructor(
    private readonly service: ConstructionSiteService,
  ) {}

  execute(cmd: CreateConstructionSiteIntakeCommand): Promise<ConstructionSite> {
    return this.service.createIntake(cmd);
  }
}
